import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

const getOnlineStatus = (): boolean => {
	if (typeof navigator === "undefined") {
		return true
	}
	return navigator.onLine
}

export const NetworkStatusBanner = () => {
	const { t } = useTranslation("components")
	const [isOnline, setIsOnline] = useState(getOnlineStatus)

	useEffect(() => {
		const handleOnline = () => setIsOnline(true)
		const handleOffline = () => setIsOnline(false)

		window.addEventListener("online", handleOnline)
		window.addEventListener("offline", handleOffline)

		return () => {
			window.removeEventListener("online", handleOnline)
			window.removeEventListener("offline", handleOffline)
		}
	}, [])

	if (isOnline) {
		return null
	}

	return (
		<div className="pointer-events-none fixed inset-x-0 top-10 z-[20050] flex justify-center p-2">
			<div
				role="status"
				aria-live="polite"
				className="rounded-md bg-red-700 px-4 py-1.5 text-xs font-medium text-white shadow-lg"
			>
				{t("networkStatusBanner.noInternet")}
			</div>
		</div>
	)
}
